import { useCallback } from "react";
import { graphql, useMutation } from "react-relay/hooks";

import type { unclaimDeviceMutation } from "__generated__/unclaimDeviceMutation.graphql";

const requestUnclaimDeviceMutation = graphql`
  mutation unclaimDeviceMutation($deviceNodeId: ID!, $connections: [ID!]!) {
    unclaimDevice(deviceNodeId: $deviceNodeId) {
      accessPoint {
        id @deleteEdge(connections: $connections)
      }
      attachment {
        id @deleteEdge(connections: $connections)
      }
      battery {
        id @deleteEdge(connections: $connections)
      }
      controller {
        id @deleteEdge(connections: $connections)
      }
      dock {
        id @deleteEdge(connections: $connections)
      }
      sensor {
        id @deleteEdge(connections: $connections)
      }
      vehicle {
        id @deleteEdge(connections: $connections)
      }
      gimbal {
        id @deleteEdge(connections: $connections)
      }
      errors
    }
  }
`;

export const useUnclaimDevice = (
  onCompleted?: (response: unclaimDeviceMutation["response"]) => void
) => {
  const [requestUnclaimDevice, loading] = useMutation<unclaimDeviceMutation>(
    requestUnclaimDeviceMutation
  );

  const callback = useCallback(
    (deviceNodeId: string, connections: string[]) =>
      requestUnclaimDevice({
        variables: { deviceNodeId, connections },
        onCompleted,
      }),
    [requestUnclaimDevice, onCompleted]
  );

  return [callback, loading] as [typeof callback, boolean];
};
